import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { services } from '../data/expertise';
interface AdvisoryServicesProps {
  onRequestBriefing: () => void;
}
export function AdvisoryServices({
  onRequestBriefing
}: AdvisoryServicesProps) {
  return <section id="advisory" className="scroll-mt-16 bg-canvas" data-id="element-12" data-mp="1x4gu0ofi7w4b">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-28" data-id="element-13" data-mp="2kt0150mti2ut">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end" data-id="element-14" data-mp="2kqvo9t6xxtie">
          <SectionHeading index="II" title="Advisory & Board Engagement" description="Conroy Advisory Group, LLC advises owners, boards, and contractors on the decisions made before capital is committed — and the governance that holds delivery together afterward." data-id="element-15" data-mp="2otsdi2qzknvb" />
          <button type="button" onClick={onRequestBriefing} className="focus-ring group inline-flex shrink-0 items-center gap-2 self-start rounded-sm border border-navy px-6 py-3.5 text-sm font-semibold text-navy transition-colors duration-150 ease-exec hover:bg-navy hover:text-white lg:self-auto" data-id="element-16" data-mp="zhq9u4h0vrh3">
            Discuss an engagement
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-exec group-hover:translate-x-1" aria-hidden="true" data-id="element-17" data-mp="2ij7w08yowfhq" />
          </button>
        </div>

        <ul className="mt-14 grid gap-px bg-steel-200 lg:grid-cols-3" data-id="element-18" data-mp="2rgi81wjc08np">
          {services.map(service => <li key={service.number} className="flex flex-col bg-white p-8 lg:p-10" data-id="element-19" data-mp="2nf6oa7n52hnf">
              <span className="font-serif text-sm text-bronze-600" data-id="element-20" data-mp="31aij0f1ao84c">
                {service.number}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-snug text-navy" data-id="element-21" data-mp="3b6ln3qfpigtx">
                {service.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-steel-400" data-id="element-22" data-mp="368acveli24b6">
                {service.summary}
              </p>
              <ul className="mt-auto space-y-3 border-t border-steel-100 pt-6" data-id="element-23" data-mp="3dca5xfeqnu6y">
                {service.scope.map(item => <li key={item} className="flex gap-3" data-id="element-24" data-mp="3i7fn60x74kop">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-bronze-600" aria-hidden="true" data-id="element-25" data-mp="3n83eyot915jz" />
                    <span className="text-sm text-navy-700" data-id="element-26" data-mp="ttqkfpbjxj7">{item}</span>
                  </li>)}
              </ul>
            </li>)}
        </ul>
      </div>
    </section>;
}